import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _typeof from 'babel-runtime/helpers/typeof';
import URL from 'url-parse';
import { parseParams, stringifyParams } from 'location-search-string';
import { replace } from 'react-router-redux';
import { jsonResponse } from 'fetch-utilities';

/*
  view.js
  ------------------------------------------------------------

  Load data by URL and assign the proper type to the
  application state depending on what we get back
*/


var HINT = "store/view/HINT";

var VIEW_LOADED = "store/view/LOADED";

/**
 * Hints of an upcoming navigation-event with data.
 *
 * The `url` is expected to be the last segment of the URL being hinted (excluding leading).
 */
var hint = function hint(type, url, data) {
  return {
    type: HINT,
    hintUrl: url,
    hintType: type,
    hintData: data
  };
};

/*
  category.js
  ------------------------------------------------------------

  Load a single category
*/

var CATEGORY_TYPE = "category";

var PENDING = 'store/category/PENDING';
var HINTED = 'store/category/HINTED';
var LOADED = 'store/category/LOADED';
var SET_PAGE_SIZE = 'store/category/SET_PAGE_SIZE';

var PAGE_REQUESTING = 'store/category/PAGE_REQUESTING';
var PAGE_REQUESTED = 'store/category/PAGE_REQUESTED';

var initialState = {
  // TODO: Should be removed
  state: PENDING,
  requested: [],
  pages: [],
  category: null,
  pageSize: 20,
  // Number of total products in the category
  total: 0
};

function reducer$$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var requested = void 0,
      pages = void 0;

  switch (action.type) {
    case VIEW_LOADED:
      if (action.error || _typeof(action.payload) !== "object" || action.payload.type !== CATEGORY_TYPE) {
        // Reset when we load another view
        return _extends({}, initialState, {
          pageSize: state && state.pageSize || initialState.pageSize
        });
      }

      var params = parseParams(new URL(action.url).query);
      var _action$payload$categ = action.payload.category,
          category = _action$payload$categ.category,
          products = _action$payload$categ.products;

      var page = Math.max(params.page | 0 || 1, 1);

      return _extends({}, state, {
        state: LOADED,
        total: category.productCount,
        // We only ever requested one page when we initially load a category
        pages: [{
          index: (page - 1) * state.pageSize,
          page: page,
          items: products
        }],
        category: category
      });
    case HINT:
      if (action.hintType !== CATEGORY_TYPE) {
        return state;
      }

      return _extends({}, state, {
        state: HINTED,
        requested: [],
        pages: [],
        total: 0,
        category: action.hintData
      });

    case PAGE_REQUESTING:
      if (state.state !== LOADED || state.category.id !== action.categoryId) {
        return state;
      }

      pages = state.pages.filter(function (p) {
        return action.requested.indexOf(p.page) !== -1;
      });

      return _extends({}, state, {
        pages: pages,
        requested: action.requested
      });

    case PAGE_REQUESTED:
      if (state.state !== LOADED || state.category.id !== action.categoryId) {
        return state;
      }

      var existingPages = state.pages.map(function (p) {
        return p.page;
      });

      pages = state.pages.slice();

      for (var i = 0; i < action.payload.length; i++) {
        if (existingPages.indexOf(action.payload[i].page) === -1) {
          pages.push(action.payload[i]);
        }
      }

      pages.sort(function (a, b) {
        return a.page - b.page;
      });

      return _extends({}, state, {
        pages: pages
      });
    case SET_PAGE_SIZE:
      return _extends({}, state, {
        pageSize: action.size
      });
    default:
      return state;
  }
}

var hintCategory = function hintCategory(category) {
  return hint(CATEGORY_TYPE, category.urlKey, category);
};

/**
 * Requests a list of pages to be made available for the current category.
 */
var requestPages = function requestPages(requestedPages) {
  return function (dispatch, getState, client) {
    var state = getState();
    var _state$category = state.category,
        requested = _state$category.requested,
        pages = _state$category.pages,
        category = _state$category.category,
        pageSize = _state$category.pageSize;


    if (!category) {
      // We do not have a loaded category
      return;
    }

    var location = state.router.location;

    var loaded = pages.map(function (p) {
      return p.page;
    });

    var promises = requestedPages.filter(function (p) {
      return requested.indexOf(p) === -1 && loaded.indexOf(p) === -1;
    }).map(function (p) {
      return client("/categories/" + category.id + "?page=" + p).then(jsonResponse).then(function (payload) {
        return {
          index: (p - 1) * pageSize,
          page: p,
          items: payload.products
        };
      });
    });

    if (promises.length === 0) {
      return;
    }

    // Update query-parameter as we scroll
    dispatch(replace(_extends({}, location, {
      search: stringifyParams(_extends({}, parseParams(location.search), {
        // Skip page 1, use canonical URL for it
        page: requestedPages[0] == 1 ? undefined : requestedPages[0]
      }))
    })));

    dispatch({
      type: PAGE_REQUESTING,
      categoryId: category.id,
      requested: requestedPages
    });

    dispatch({
      type: PAGE_REQUESTED,
      categoryId: category.id,
      requested: requestedPages,
      payload: _Promise.all(promises)
    });
  };
};

var setPageSize = function setPageSize(size) {
  return {
    type: SET_PAGE_SIZE,
    size: size
  };
};

export { PENDING, HINTED, LOADED, SET_PAGE_SIZE, hintCategory, requestPages, setPageSize };
export default reducer$$1;
